import { Injectable } from "@angular/core";
import { IShiftTimingModel } from "@core/models/iShiftTimingModel";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { ShiftTimingActionStore } from "./shiftTimingStore.action";



@State<IShiftTimingModel>({
  name: 'shiftTimings',
  defaults: {
    startTime: '',
    endTime: ''
  }
})

@Injectable()
export class ShiftTimingStateStore {
  @Selector()
  static getNurseShiftTiming(state: IShiftTimingModel) {
    return state;
  }

  @Action(ShiftTimingActionStore)
  updateShiftTiming(
    { getState, patchState }: StateContext<IShiftTimingModel>,
    { payload }: ShiftTimingActionStore
  ) {
    const state = getState();

    patchState({
      startTime: payload.startTime,
      endTime: payload.endTime
    })
  }
}